import { useInfiniteQuery } from 'react-query';
import { ApiCollectionResponse } from 'types/api_response';
import { baseApiUrl, fetcher } from 'data_sources/constants';
import { ServerErrorResponse } from 'data_sources/constants';
import { UserListResult } from 'views/App/Portal/Reporting/Users/_types/users';
export default function useUsersReport<T extends UserListResult>(
  orgId: string,
  params: Record<string, any> = {},
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexid/reports/v1/organizations/${orgId}/reports/users`;
  return useInfiniteQuery<ApiCollectionResponse<T>, Error>(
    ['reporting_users', orgId, params],
    async ({ pageParam = 0, signal }): Promise<ApiCollectionResponse<T>> => {
      const paramString = new URLSearchParams(
        Object.entries({
          ...params,
          offset: pageParam,
        })
          .filter(([_k, v]) => v != null)
          .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
      ).toString();
      const data: ApiCollectionResponse<T> = await fetcher({
        method: 'get',
        url: `${url}?${paramString}`,
        options: { signal },
      });
      return data;
    },
    {
      ...options,
      keepPreviousData: true,
      getNextPageParam: (lastPage) => {
        if (
          lastPage?.offset != null &&
          lastPage?.count != null &&
          lastPage.offset < lastPage.count &&
          Array.isArray(lastPage.content) &&
          lastPage.content.length > 0
        ) {
          return lastPage.offset;
        }
        return undefined;
      },
    }
  );
}
